import { Button } from '@breetometer/components';
import { PlusIcon } from 'BreetAssets';
import { BeneficiaryList } from 'BreetComponents';
import { type IBeneficiariesProps, type IBeneficiary } from 'BreetHelpers';
import { openModal, selectBeneficiaries, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

const Beneficiaries = ({
	onAddNewBeneficiary,
	title,
	selectBeneficiary,
	selectedBeneficiaryId,
	onManageBeneficiaries,
	mode = 'select',
}: IBeneficiariesProps) => {
	const dispatch = useAppDispatch();

	const beneficiaries = useAppSelector(selectBeneficiaries);

	const selectedBeneficiary = beneficiaries.find((i) => i._id === selectedBeneficiaryId);

	const handleBeneficiarySelection = useCallback(
		(beneficiary: IBeneficiary, modeArg: 'delete' | 'select') => () => {
			if (modeArg === 'delete') {
				dispatch(
					openModal({
						id: 'deletebeneficiary',
						metadata: { id: beneficiary._id, isAutoSettlementBeneficiary: beneficiary.autoSettlement },
						hideCloseButton: true,
					})
				);
			} else {
				selectBeneficiary(beneficiary);
			}
		},
		[dispatch, selectBeneficiary]
	);

	const handleNewBeneficiary = useCallback(() => {
		selectBeneficiary(undefined);
		onAddNewBeneficiary?.();
	}, [onAddNewBeneficiary, selectBeneficiary]);

	const isMaxBeneficiaries = beneficiaries.length === 3;

	return (
		<div
			className='payment-request-form_beneficiarysection'
			data-testid='beneficiaries'
		>
			<BeneficiaryList
				title={title}
				beneficiaries={beneficiaries}
				handleBeneficiarySelection={handleBeneficiarySelection}
				selectedBeneficiaryId={selectedBeneficiary?._id}
				mode={mode}
				hideHeader={mode === 'delete'}
			/>

			{mode === 'select' ? (
				<div className='payment-request-form_beneficiarysectioncta'>
					{!isMaxBeneficiaries && (
						<Button
							label='Add Account'
							variant='primary'
							type='button'
							onClick={handleNewBeneficiary}
						/>
					)}
					<Button
						label='Manage Accounts'
						variant='tertiary'
						type='button'
						onClick={onManageBeneficiaries}
					/>
				</div>
			) : (
				!isMaxBeneficiaries && (
					<div className='managebeneficiary_cta'>
						<Button
							leadingIcon={<PlusIcon className='addaccounticon' />}
							label='Add Account'
							variant='tertiary'
							onClick={handleNewBeneficiary}
						/>
					</div>
				)
			)}
		</div>
	);
};

export default Beneficiaries;
